import { Button, Link } from "@shapr3d/frontend-lib";

import { supportEmail } from "../../config";
import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./ZendeskLogOut.module.css";

interface ZendeskLogOutProps {
  errorMessage?: string;
}

const ZendeskLogOut = (props: ZendeskLogOutProps) => {
  const navigation = useNavigation();
  const { t, m } = useTranslation();

  const backToProfileButton = (
    <Button onClick={() => navigation.goToProfile()} className={style.button}>
      {t(m.Edu.BackToMyProfile)}
    </Button>
  );

  if (props.errorMessage) {
    return (
      <div className={style.container}>
        <div className={style.content}>
          <Heading type="h1">{t(m.ZendeskLogOut.LoggedOutFromSupportPortal)}</Heading>
          <div className={style.text}>
            {t(m.ZendeskLogOut.ErrorBody)}
            <br />
            {props.errorMessage}
            <br />
            <br />
            {t(m.ZendeskLogOut.TryAgain, {
              link: (chunks) => <NewZendeskTicketLink>{chunks}</NewZendeskTicketLink>,
              email: () => <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>,
            })}
          </div>
          {backToProfileButton}
        </div>
      </div>
    );
  } else {
    return (
      <div className={style.container}>
        <div className={style.content}>
          <Heading type="h1">{t(m.ZendeskLogOut.LoggedOutFromSupport)}</Heading>
          <div className={style.text}>{t(m.ZendeskLogOut.SuccessBody)}</div>
          {backToProfileButton}
        </div>
      </div>
    );
  }
};

export default ZendeskLogOut;
